import { motion } from "@/lib/motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease }}
        className={className}
        {...rest}
    >
        {children}
    </motion.div>
);

// Section label (design system "Label"): a soft green pill with deep green text on light pages
// (Green with navy text on dark pages), Poppins, Title Case,
// 28px tall. It sits above the section title and organizes every page.
export const Overline = ({ children, className = "" }) => (
    <span
        className={`inline-flex h-7 items-center rounded-full bg-[color:var(--el-label-bg)] px-[15px] font-body text-[15px] font-normal leading-7 text-[color:var(--el-label-ink)] ${className}`}
    >
        {children}
    </span>
);
